import { require_jsx_runtime as e } from "./index21.js";
import { blablacar as t } from "./index326.js";
import { ThemeProvider as n } from "@mui/material";
//#region src/theme/blablacar/BlablacarThemeProvider.tsx
var r = e(), i = ({ children: e }) => /* @__PURE__ */ (0, r.jsx)(n, {
	theme: t,
	children: e
});
//#endregion
export { i as BlablacarThemeProvider };

//# sourceMappingURL=index329.js.map